import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '@/components/layout/Header';
import Sidebar from '@/components/layout/Sidebar';
import Content from '@/components/layout/Content';
import Footer from '@/components/layout/Footer';
import { EmbeddingSyncProvider } from '@/contexts/EmbeddingSyncContext';

const PageFallback: React.FC = () => (
  <div
    className="flex h-full min-h-[240px] items-center justify-center text-sm"
    style={{ color: 'var(--hub-ink-3)' }}
  >
    Loading...
  </div>
);

const MainLayout: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <EmbeddingSyncProvider>
      <div
        className="flex flex-col h-screen"
        style={{ background: 'var(--hub-bg)', color: 'var(--hub-ink)' }}
      >
        {/* Header: full width, always on top */}
        <Header onToggleSidebar={toggleSidebar} />

        {/* Middle: Sidebar + Content (fills remaining space between Header & Footer) */}
        <div className="flex flex-1 min-h-0">
          <Sidebar collapsed={sidebarCollapsed} />
          <Content>
            <Suspense fallback={<PageFallback />}>
              <Outlet />
            </Suspense>
          </Content>
        </div>

        {/* Footer: full width, always on bottom */}
        <Footer />
      </div>
    </EmbeddingSyncProvider>
  );
};

export default MainLayout;